import React, { useEffect ,useState} from 'react'
import { CloseButton, Col, Container, container, Row } from 'react-bootstrap'
import './projectdescriptiom.css'
import { AiFillCloseCircle, AiFillDelete } from 'react-icons/ai'
import { useContext } from 'react'
import { ShowContext } from '../../context/showContext'
export default function Projectdescription() {
    const [desc,setdescr]=useState({})
    const {dispatch,desProject} = useContext(ShowContext)


  return (
    <div className='detail' >
        <Container className='  Container'>
            <Col className='desc_box'>
            <Row className='cardtop'>
                    <AiFillCloseCircle size="3em" onClick={()=>dispatch({type:"TOGGLE"})} className='close-btn'/>
                <h2>{desProject.Title}</h2>
            </Row>
            <Row>
                <h3>Description</h3>
                <p>{desProject.Desc}</p>
            </Row>
            <Row>
            <h3>Tech Used</h3>
            <p>{desProject.TechUsed}</p>
            </Row>            
            </Col>
        </Container>
    </div>
  )
}
